"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const queryString = require("query-string");
exports.createRoute = (
/** A page of Next.js. This is a path of files in `/pages` in general. */
path, 
/**
 * An object for dynamic parameters.
 * @default {}
 */
parameters = {}, 
/**
 * An object for query string.
 * @default {}
 */
queryParameters = {}) => {
    const pagePath = path.replace(/^\/*/, "/");
    const completedURISegments = [];
    const segments = pagePath.split("/");
    segments.forEach((segment) => {
        const newSegment = (() => {
            var _a;
            const matches = segment.match(/\[(.*?)\]/);
            if (matches == undefined)
                return segment;
            const parameterName = matches[1];
            return _a = parameters[parameterName], (_a !== null && _a !== void 0 ? _a : segment);
        })();
        completedURISegments.push(newSegment.toString());
    });
    const queries = queryString.stringify(queryParameters);
    const querySeparator = queries && "?";
    const pagePathWithQueries = pagePath + querySeparator + queries;
    const completedURI = completedURISegments.join("/") + querySeparator + queries;
    return { href: pagePathWithQueries, as: completedURI };
};
